<template>
  <router-link class="product-card" :to="`/shop/products/${flower.id}`">

    <ProductImage :src="image" />

    <div class="content">
      <div class="text-caption farm_name">{{ flower.farm.name }}</div>
      <div class="d-flex justify-space-between mb-1">
        <div class="genus-name">{{ flower.flower_specie.flower_genus.name }}</div>
      </div>
      <div class="name">{{ flower.flower_specie.name }}</div>
      <span class="request_only" v-if="flower.request_only">{{ $t("only_request") }}</span>
      <div v-if="flower.earliest_delivery_date">
        <div class="detail">
          <div class="earliest_delivery_date">
            <span>{{ $d(flower.earliest_delivery_date, 'shortDate') }}</span>
            <span class="earliest_delivery_date_wday">（{{ $d(flower.earliest_delivery_date, 'day') }}）〜</span>
          </div>
          <div class="lowest_price"><span class="lowest_price_break_line">¥{{ $n(flower.lowest_prices.sales_price) }}</span>
            <span class="lowest_price_tax">
              <span class="lowest_price_break_line">
                （内送料
              </span>
              <span class="lowest_price_break_line">
                ¥{{ $n(flower.lowest_prices.delivery_fee) }}）〜
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>

import ProductImage from "@/components/shop/products/ProductImage.vue";

export default {
  components: {
    ProductImage,
  },

  props: {
    flower: {
      type: Object,
      required: true
    }
  },
  computed: {
    image() {
      return this.flower.thumbnail;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-card {
  display: block;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
}

.content {
  padding: 18px 12px 30px;
}

.name {
  color: #333;
  font-size: 15px;
  font-weight: bold;
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.genus-name {
  color: #333;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.color {
  margin: 8px 8px 8px 0;
}

.destination {
  font-size: 12px;
  color: #777;
  line-height: 20px;
  height: 60px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.detail {
  color: #555;
  font-size: 12px;
  margin-top: 11px;
  border-top: 1px solid #CCCCCC;
  padding-top: 11px;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;

  .earliest_delivery_date {
    margin-bottom: 8px;

    &_wday {
      font-size: 10px;
      line-height: 12px;
    }
  }

  .lowest_price {
    overflow-wrap: anywhere;
    color: #FF8C71;

    &_break_line {
      display: inline-block;
    }

    &_tax {
      font-size: 10px;
      line-height: 12px;
    }
  }
}

.request_only {
  background-color: #FF8C71;
  color: #fff;
  font-weight: bold;
  font-size: 12px;
  opacity: .8;
  padding: 5px;
}

.farm_name {
  color: #007e57;
}
</style>
